/* Public client API only. No opt-in, list membership or private credentials. */
(function () {
  'use strict';
  window.RMSurveySubmit = async function (submission) {
    if (!submission || typeof submission.email !== 'string' || submission.email.length > 254 ||
        !/^[^\s@<>"\x00-\x1F\x7F]+@[^\s@<>"\x00-\x1F\x7F]+\.[^\s@<>"\x00-\x1F\x7F]+$/.test(submission.email) ||
        !Array.isArray(submission.answers) || submission.answers.length !== 3 ||
        submission.answers.some(function (answer) { return typeof answer !== 'string' || !answer.trim() || answer.length > 2000; }) ||
        !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(submission.submissionId || '') ||
        typeof submission.completedAt !== 'string' || !Number.isFinite(Date.parse(submission.completedAt))) {
      throw new TypeError('Please check your email and complete all three answers.');
    }
    var answers = submission.answers;
    var properties = {
      RM_PP_Survey_Reason: answers[0],
      RM_PP_Survey_Wear: answers[1],
      RM_PP_Survey_Next: answers[2],
      RM_PP_Survey_Completed: true,
      RM_PP_Survey_Completed_At: submission.completedAt,
      RM_PP_Survey_Version: 'rm_post_purchase_v1',
      RM_PP_Survey_Submission_ID: submission.submissionId,
      RM_PP_Survey_Schema_Version: 1,
      RM_PP_Survey_Source: 'shopify_post_purchase_survey',
      RM_PP_Survey_Language: 'EN'
    };
    var payload = {data: {type: 'event', attributes: {
      metric: {data: {type: 'metric', attributes: {name: 'RM Post-Purchase Survey Completed'}}},
      profile: {data: {type: 'profile', attributes: {email: submission.email, properties: properties}}},
      properties: {
        survey_id: 'rm_post_purchase_v1', schema_version: 1,
        submission_id: submission.submissionId, completed_at: submission.completedAt,
        answer_count: answers.length,
        reason: answers[0], wear: answers[1], next_product: answers[2],
        language: 'EN', source: 'shopify_post_purchase_survey'
      },
      unique_id: submission.submissionId,
      time: submission.completedAt
    }}};
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch('https://a.klaviyo.com/client/events/?company_id=UtQgz9', {
        method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer',
        headers: {'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15'},
        body: JSON.stringify(payload), signal: controller.signal
      });
      if (!response.ok || response.status !== 202) throw new Error('Survey could not be saved. Please try again.');
    } finally {
      clearTimeout(timeout);
    }
  };
}());
